import applicationDraftReducer  from "./applicationDraftReducer";

const applicationDraftReducers = {
    applicationDraft: applicationDraftReducer
}

export default applicationDraftReducers;